import { gql } from '@apollo/client';

export const fetchTermDetailsPPC = gql`
  query fetchTermDetailsPPC($id: ID!) {
    transactionAccount(id: $id) {
      id
      transactionAccountNumber
      availablePaymentMethods {
        totalCount
        nodes {
          id
          type
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
              payOnStatement
            }
            totalCreditLimit
            paymentMethod
          }
        }
      }
      billToParty {
        name
        taxId
        state
        taxExempt
        taxIds {
          id
          label
          displayName
          metadata {
            vatStatus
          }
          taxExempt
        }
        addressLine1
        addressLine2
        city
        country
        state
        taxLabels {
          region
          taxIdLabels {
            type
            displayName
            description
            metadata {
              type
              labels {
                label
                vatStatus
                default
              }
            }
          }
        }
      }
      billingAccountsList {
        totalCount
        totalCreditLimit
        creditOutstanding
        availableCreditLimit
        paymentMethod
        currency
        status
        nodes {
          creditOutstanding
          status
          customerName
          transactionAccountNumber
          pendingInvoiceRequestsTotal
          taxId
        }
      }
    }
  }
`;
